import React from "react";
import styled from "styled-components";

export function RequiredIndicator() {
  return <RequiredStyles>*</RequiredStyles>;
}

const RequiredStyles = styled.span`
  color: var(--thunderbird);
`;
